import { useActiveProjectUuid } from '../../hooks/useActiveProject';
import { useProjectUuid } from '../../hooks/useProjectUuid';
import useFullscreen from '../../providers/Fullscreen/useFullscreen';
import { useCompactNavigation } from './useCompactNavigation';

/**
 * The project uuid when the sidebar is shown, else undefined. Shared so the
 * navbar hides exactly the menus the sidebar renders, never both or neither.
 */
export const useProjectSidebarVisible = (
    withProjectSidebar: boolean,
): string | undefined => {
    const compact = useCompactNavigation();
    const { isFullscreen } = useFullscreen();
    const { activeProjectUuid } = useActiveProjectUuid({
        projectUuid: useProjectUuid(),
    });
    // Desktop only: phones keep the navbar drawer, and fullscreen gets the
    // whole screen.
    return withProjectSidebar && !compact && !isFullscreen
        ? activeProjectUuid
        : undefined;
};
